<template>
  <app-context-menu
    :options="options"
    ref="actionsContextMenu"
    element-id="actionsContextMenu"
    @option-clicked="optionClicked"
  >
  </app-context-menu>
</template>

<script>
import AppContextMenu from '@/components/app-context-menu/';
import ActionsMenuMixin from '@/mixins/actions-menu';

export default {
  name: 'ActionsContextMenu',
  components: { AppContextMenu },
  mixins: [ActionsMenuMixin],
  methods: {
    showMenu(event, invoice) {
      this.filterData.status = invoice.invoice_type;
      this.getEInvoiceData(invoice).then(res => this.$refs.actionsContextMenu.showMenu(event, res));
    },
    hideContextMenu() {
      this.$refs.actionsContextMenu.hideContextMenu();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/portal-components/invoice/actions-menu/actions-context-menu.vue